import { uniqueKey } from 'global/common/keys'
import Checker from 'global/components/forms/elements/Checker'
import DropdownInput from 'global/components/forms/elements/DropdownInput'
import HtmlEditor from 'global/components/forms/elements/HtmlEditor'
import TextAreaInput from 'global/components/forms/elements/TextAreaInput'
import { FormItemsAlt } from 'global/components/forms/FormItemsAlt'
import { FormPreview } from 'global/components/forms/FormPreview'
import { gEnums } from 'global/enums/globalEnums'
import _ from 'lodash'
import { useContext, useEffect, useMemo, useState } from 'react'
import { Divider, Dropdown, Form, Icon, Input } from 'semantic-ui-react'
import Wrapper, { wrapperTypes } from './Wrapper'
import { SquaresContext } from './SquaresWrapper'
import { useDynamicListOptions } from 'global/cnr/contexts/useHelpers/optionsBuilder/useDynamicListOptions'
import { appIconTypes } from 'global/enums/appIconTypes'

const _showLogs = false

const SquaresForm = ({
  handle_formUpdate,
  currentGroup,
  currentData,
  currentPath,
  currentPathFull,
  currentViProps,
  onSave,
}) => {

  const squaresContext = useContext(SquaresContext)
  const { squares_state } = squaresContext ?? {}
  const { pageView, view } = squares_state ?? {}
  const zzz = squares_state?.apsViews?.[pageView]
  const xxx = _.get(zzz, squares_state?.keyPath, {});

  const [localData, setLocalData] = useState(currentData);
  const { groupItems, key: formKey } = currentGroup

  const { getDynOption } = useDynamicListOptions()

  const [htmlProps, setHtmlProps] = useState()

  useEffect(() => {
    setLocalData(currentData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentData]);

  console.log('groupItems', groupItems)

  const setPropFormAllow = (formData, propKey, data_itemProp) => {

    const { formItemType, dataListType, showIfProp, showIfProps, showIfPropValues, showIfPropsValues, showIfNotPropValues, showIfPropExists } = data_itemProp ?? {}

    let allow = true

    let allowAny = formData && showIfPropValues && showIfPropValues.includes('ANY') && showIfProp && formData[showIfProp] && formData[showIfProp].length > 0

    // if (viewPropsAllowed) { if (!viewPropsAllowed.includes(propKey)) { allow = false } }
    if (showIfProp && formData) { if (showIfPropValues && !allowAny) { if (!showIfPropValues.includes(formData[showIfProp])) { allow = false } } }
    if (showIfNotPropValues) { if (showIfNotPropValues.includes(formData[showIfProp])) { allow = false } }
    if (showIfPropExists) { if (!formData[showIfPropExists]) { allow = false } }
    if (propKey && propKey.toLowerCase().indexOf('ampm') >= 0) { allow = false }

    switch (formItemType) {
      case gEnums.formItemTypes.colorSelect:
      case gEnums.formItemTypes.colorSelectSingle:
        // nothing
        break;
      default:
        break;
    }

    switch (propKey && propKey.toLowerCase()) {
      case 'fsid':
      case 'key':
        allow = false
        break;
      default:
      // nothing
    }

    if (formData && showIfProps && showIfPropsValues && (showIfProps.length === Object.keys(showIfPropsValues).length)) {
      let _allow = true
      showIfProps.forEach((_showIfProp, index) => {
        try {
          const _formValue = formData[_showIfProp]
          const _valueArray = showIfPropsValues[index + 1]
          if (_formValue && _valueArray) {
            if (!_valueArray.includes(_formValue)) {
              _allow = false
            }
          } else {
            _allow = false
          }
        } catch (error) {
          console.error(error)
        }
      })
      allow = _allow
    }

    return allow
  }

  const _groupItems = useMemo(() => {
    return _.chain(groupItems)
      .cloneDeep()
      .sortBy('_position')
      .filter(gi => {
        const { data, prop } = gi ?? {}
        const { showIfProp, showIfProps, showIfPropValues, showIfPropsValues } = data || {}

        const _alloww = setPropFormAllow(localData, prop, data)
        return _alloww

        // if (showIfProp) {
        //   console.log('showIfProp', showIfProp, localData?.[showIfProp])
        // }

        // // single-prop condition (existing behavior)
        // if (showIfProp && !localData?.[showIfProp]) {
        //   return false
        // }

        // // multi-prop condition
        // if (
        //   showIfProps &&
        //   showIfPropsValues &&
        //   Array.isArray(showIfProps) &&
        //   showIfProps.length === Object.keys(showIfPropsValues).length
        // ) {
        //   let allow = true

        //   showIfProps.forEach((propKey, index) => {
        //     try {
        //       const formValue = localData?.[propKey]
        //       const allowedValues = showIfPropsValues[index + 1]

        //       if (!formValue || !Array.isArray(allowedValues)) {
        //         allow = false
        //         return
        //       }

        //       if (!allowedValues.includes(formValue)) {
        //         allow = false
        //       }
        //     } catch (err) {
        //       console.error(err)
        //       allow = false
        //     }
        //   })

        //   return allow
        // }

        // return true
      })
      .value()
  }, [groupItems, localData])

  if (_showLogs) {
    console.group('SquaresForm')
    console.log('localData', localData)
    console.log('currentGroup', currentGroup)
    console.log('currentViProps', currentViProps)
    console.log('groupItems', groupItems)
    console.log('currentData', currentData)
    console.log('pageView', pageView)
    console.groupEnd()
  }

  const debouncedUpdate = useMemo(
    () =>
      _.debounce((data) => {
        handle_formUpdate(data, currentPath, currentPathFull);
      }, 300),
    [currentPath, handle_formUpdate]
  );

  /**
   * handles changes to any of the form items
   * @param {*} propName 
   * @param {*} value 
   * @param {*} c 
   * @param {*} list 
   */
  const handleChange = (propName, value, c, list) => {
    const _propName = propName || value?.propname

    let _value;

    if (list) {
      _value = list
    } else {
      if (_.isObject(value)) {
        if (value.value) {
          _value = value.value
        } else {
          _value = value
        }
      } else {
        _value = value
      }
    }

    if (_showLogs) {
      console.group('Handle Change')
      console.log('formKey', formKey)
      console.log('localData', localData)
      console.log('_propName', _propName)
      console.log('value before', _value)
      console.log(`Changes the value of '${_propName}' in '${formKey}'`)
    }

    setLocalData(prev => {
      const next = _.cloneDeep(prev);
      _.set(next, _propName, _value);
      if (_showLogs) {
        console.log('value after', next)
        console.groupEnd()
      }
      debouncedUpdate(next);
      return next;
    });
  };

  const handleEditor = (editorProps, prop) => setHtmlProps(!htmlProps ? editorProps : null)

  const handleUpdate_html = (a, b) => {
    const { propname, value } = b ?? {}
    handleChange(propname, value)
    setHtmlProps()
  }

  const divHeader = (bb, key) => <Divider className='inl' key={uniqueKey('fi', 'bb', key)} horizontal >
    <Icon name={'object ungroup outline'} color={'blue'} style={{ marginRight: '1em' }} />
    {bb}
  </Divider>

  const renderIcon = (name, color = 'blue', onClick) => (
    <Icon key={uniqueKey('fii-r', name)} name={name} color={color} style={{ float: 'right' }} onClick={onClick} />
  );

  const lbl = (label, urlLink, fip) => {
    const items = []
    if (urlLink) {
      items.push(renderIcon(appIconTypes.externalAlternate, urlLink, () => window.open(urlLink, '_blank')))
      items.push(renderIcon(fip.value ? fip.value : 'question circle', fip.value ? 'green' : 'grey'));
    }
    return <label>
      {label}
      {items}
    </label>
  }

  const renderFormItem = (key, item) => {
    const { prop, data, ui } = item;
    const _key = prop || key
    const { formItemType, placeholder, listType, breakBefore, previewType, urlLink } = data ?? {};
    const { caption: label } = ui ?? {};
    const _value = localData[_key]

    let _formItemType = (formItemType) || 'text'

    const { propOptions: _propOptions, formItemTypeModified } = getDynOption(item, localData, view, squares_state)

    switch (currentGroup.key) {
      case 'themeColors':
        _formItemType = gEnums.formItemTypes.colorPicker
    }

    if (formItemTypeModified) {
      _formItemType = formItemTypeModified
    }

    const fip = { propname: _key, value: _value, onChange: handleChange, label }
    const itemProp = { fip }

    switch (_formItemType) {
      case gEnums.formItemTypes.checkbox:
        return (
          <>
            {breakBefore && divHeader(breakBefore, _key)}
            <Checker key={_key} item={fip} label={label} prop={prop} handleClick={handleChange} checked={_value} wrapperType={'inline'} />
          </>
        );

      case gEnums.formItemTypes.text:
        return (
          <>
            {breakBefore && divHeader(breakBefore, _key)}
            <Form.Field key={_key}>
              {lbl(label, urlLink, fip)}
              <Input
                placeholder={placeholder || ''}
                value={_value}
                onChange={(e) => handleChange(prop, e.target.value)}
              />
            </Form.Field>
          </>
        );

      case gEnums.formItemTypes.dropdown:
      case gEnums.formItemTypes.select:
        const { propOptions } = getDynOption(item, localData, view, squares_state)
        const hasOptions = propOptions ? true : false
        return (
          <>
            {breakBefore && divHeader(breakBefore, _key)}
            <Form.Field key={_key}>
              <label style={{ color: hasOptions ? null : 'var(--sem-red-light)!important' }}>{label}</label>
              <Dropdown
                placeholder={placeholder || ''}
                fluid
                search
                selection
                multiple={_formItemType === gEnums.formItemTypes.dropdown ? true : false}
                options={propOptions || []}
                value={_value}
                className='swiper-no-swiping'
                onChange={(_, { value }) => handleChange(prop, value)}

              />
            </Form.Field>
          </>
        );

      case gEnums.formItemTypes.textArea:
      case gEnums.formItemTypes.textAreaSimple:
        return <TextAreaInput fip={fip} itemProp={{}} prop={prop} handleEditor={handleEditor} formItemType={_formItemType} />

      case gEnums.formItemTypes.dropdown:
      case gEnums.formItemTypes.dropdownAdd:
      case gEnums.formItemTypes.listSelect:
        const { propOptions: propOptions_dd } = getDynOption(item, localData, view)
        return <DropdownInput fip={fip} optionList={propOptions_dd} selectMulti={true} itemProp={{}} />

      case gEnums.formItemTypes.appUserDataConstraintList:
      case gEnums.formItemTypes.appUserDataModificationList:
      case gEnums.formItemTypes.backgroundColorSelectSingle:
      case gEnums.formItemTypes.colorPicker:
      case gEnums.formItemTypes.colorSelect:
      case gEnums.formItemTypes.colorSelectSingle:
      case gEnums.formItemTypes.dataConstraintList:
      case gEnums.formItemTypes.dataMatchConstraintList:
      case gEnums.formItemTypes.date:
      case gEnums.formItemTypes.fileManifestSelect:
      case gEnums.formItemTypes.fileSelect:
      case gEnums.formItemTypes.gridRowSelect:
      case gEnums.formItemTypes.gridRowSelectFull:
      case gEnums.formItemTypes.imagePropList:
      case gEnums.formItemTypes.itemArrayMulti:
      case gEnums.formItemTypes.itemMap:
      case gEnums.formItemTypes.listAdd:
      case gEnums.formItemTypes.listView:
      case gEnums.formItemTypes.menuItemSelect:
      case gEnums.formItemTypes.menuItemSelectFull:
      case gEnums.formItemTypes.menuItemSelectFullCount:
      case gEnums.formItemTypes.numberPicker:
      case gEnums.formItemTypes.pageConstraintList:
      case gEnums.formItemTypes.phoneNumber:
      case gEnums.formItemTypes.slider:
      case gEnums.formItemTypes.tableMap:
        return <FormItemsAlt
          formItemType={_formItemType}
          fip={fip}
          localData={localData}
          xxx={xxx}
          itemProp={itemProp}
          _key={_key}
          prop={prop}
          item={item}
          handleChange={handleChange}
          formKey={formKey}
          view={view}
        ></FormItemsAlt>

      // Add other formItemTypes here
      default:
        if (previewType) {
          return <div>
            {divHeader('Preview', _key)}
            <FormPreview
              previewType={previewType}
              formItemType={_formItemType}
              itemProp={itemProp}
              localData={localData}
            />
          </div>
        }
        return (
          <Form.Field key={_key}>
            <label>{`${_formItemType} ?`}</label>
            <Input
              placeholder={_formItemType || ''}
              value={_formItemType || _key}
            // onChange={(e) => handleChange(key, e.target.value)}
            />
          </Form.Field>
        );
    }
  };

  const handleSave = () => {
    if (onSave) onSave(localData);
  };

  const form = () => <Form style={{ padding: '0em' }} className={'frm-sf'}>
    {Object.entries(_groupItems).map(([key, item]) => renderFormItem(key, item))}
  </Form>

  const htmlForm = () => <HtmlEditor
    currentFip={{ propname: htmlProps.propname, value: htmlProps.value, label: 'test' }}
    {...htmlProps}
    handleUpdate={handleUpdate_html}
    handleEditor={handleEditor}
  />

  return (
    <Wrapper
      content={htmlProps ? htmlForm() : form()}
      wrapperType={wrapperTypes.paddedFooter}
    ></Wrapper >
  );
};

export default SquaresForm;